import { Button, Card, Heading, Paragraph } from '@deckee/deck-hand';
import React, { FC } from 'react';
import CustomDescription from '../../../shared/_deprecated/components/CustomDescription/CustomDescription';
import { CustomDescriptionType } from '../../../../models/CustomDescription.model';

export interface RegulationCardInterface {
  title: string;
  description?: string;
  customDescription?: CustomDescriptionType;
  detailsAvailable: boolean;
  url: string;
}

interface RegulationCardProps extends RegulationCardInterface {
  role: string;
  onSelectRegulation: ({ url }: { url: string }) => void;
}

const RegulationCard: FC<RegulationCardProps> = ({
  title,
  description,
  customDescription,
  detailsAvailable,
  url,
  role,
  onSelectRegulation,
}) => {
  const handleClick = () => {
    onSelectRegulation({ url });
  };
  const customDescriptionAvailable =
    customDescription && customDescription.length > 0;
  return (
    <Card role={role}>
      <Card.Heading level={6}>{title}</Card.Heading>

      <Card.Body>
        {!customDescriptionAvailable && (
          <Paragraph mb="3">{description}</Paragraph>
        )}
        {customDescriptionAvailable && (
          <CustomDescription description={customDescription} />
        )}
        {detailsAvailable && (
          <Button outlined onClick={handleClick}>
            Show details
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};

RegulationCard.defaultProps = {
  description: '',
  customDescription: undefined,
};

export default RegulationCard;
